"use client";
import React from 'react';
import { findIndex, removeIndex, addItem } from '../utils/array.js';
import { useStateCallback } from './useStateCallback.js';

/**
 * React hook to manage multiply value states
 *
 * @param initialState the initial value state
 * @example
 * ```javascript
 * const [innerValue, setInnerValue] = useMultiValue<string | number>(defaultIndex || [])
 * ```
 */
function useMultiValue(initialState = []) {
    const [value, setValue] = useStateCallback(initialState);
    const update = React.useCallback((val, callback) => {
        const pos = findIndex(value, val);
        setValue(pos >= 0 ? removeIndex(value, pos) : addItem(value, val), callback);
    }, [setValue, value]);
    return [value, update];
}

export { useMultiValue };
//# sourceMappingURL=useMultiValue.js.map
